import { useRouter } from 'next/router';
import useSWRImmutable from 'swr/immutable';
import { getManufacturers } from '../../utilities/repository';

export default function useManufacturers() {
  const { locale } = useRouter();
  const { data, error } = useSWRImmutable(
    `/api/manufacturers/${locale}`,
    (_cacheKey) => getManufacturers(locale),
    {
      revalidateOnFocus: false,
      refreshInterval: 120000,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    manufacturersOptions: data ?? [],
    isLoading: !error && !data,
    isError: error,
  };
}
